import React from 'react'
import css from './section.module.css'
import userData from './../../../../resources/UsersData'
import UserCard from './UserCard';


const Section5 = () => {
  return (
    <div className={css.section5}>
      <div className={css.div1}>
        <h4>Testimonial</h4>
        <h2>What They Say About Us</h2>
        <p>
        Uniquely promote adaptive quality vectors rather than stand-alone e-markets. pontificate alternative architectures whereas iterate.
        </p>
      </div>
      <div className={css.div2}>
      {
        userData.map((data)=>{
          return(
            <UserCard key={data.id} data = {data} />
          )
        })
      }
      </div>
    </div>
  );
};
export default Section5